import React, { useState } from 'react';
import {
  apiCallBegan,
  APICallMethods
} from '@gjensidige/se-redux-api-middleware';

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { API_OPERATIONS } from '../lib/constants/appConstants';
import { SESSION_KEYS } from '../lib/constants/appConstants';
import API_ENDPOINTS from '../lib/constants/endpoints';
import {
  getSaveAndSendStatus,
  getSelectedPackages,
  onApiError,
  onApiSuccess,
  updateSaveAndSendStatus
} from '../store/slices/offerSlice';
import { SaveOfferModal } from '../components/Summary/SaveOfferModal';
import { Package, SaveAndSendOfferStatus } from '../interfaces/Types';
import { APIHelper } from '../utils/ApiHelper';

export const SaveOfferContainer: React.FC = () => {
  const [emailStatus, setEmailStatus] = useState({ email: '', isValid: false });
  const dispatch = useAppDispatch();
  const handleEmailChange = (email: string, isValid: boolean) => {
    setEmailStatus({ email, isValid });
    dispatch(updateSaveAndSendStatus('idle'));
  };
  const offerInfo = useAppSelector((state) => state.insurance.offer);
  const selectedPackages = useAppSelector(getSelectedPackages);
  const selectedInsurancePackage = selectedPackages.find(
    (packageItem: Package) => !packageItem.isPlusPackage
  );
  const selectedAdditionalPackages = selectedPackages.filter(
    (packageItem: Package) => packageItem.isPlusPackage
  );
  const isPlusPacketSelected = selectedPackages.some(
    (packageItem: Package) => packageItem.isPlusPackage
  );
  const genericIllustrations = JSON.parse(
    sessionStorage.getItem(SESSION_KEYS.GENERIC_ILLUSTRATIONS) || '{}'
  );
  const submitStatus: SaveAndSendOfferStatus =
    useAppSelector(getSaveAndSendStatus);
  const onModalClose = () => {
    setEmailStatus({ email: '', isValid: false });
    dispatch(updateSaveAndSendStatus('idle'));
  };

  const handleSaveOffer = () => {
    const saveOfferPayload = APIHelper.getSaveOfferPayload(
      offerInfo,
      selectedInsurancePackage,
      selectedAdditionalPackages,
      isPlusPacketSelected,
      offerInfo.productName,
      emailStatus.email
    );
    dispatch(updateSaveAndSendStatus('pending'));
    dispatch(
      apiCallBegan({
        init: saveOfferPayload,
        url: API_ENDPOINTS.saveAndSendOfferURL,
        apiOperation: API_OPERATIONS.SAVE_AND_SEND_OFFER,
        method: APICallMethods.POST_JSON,
        onStart: '',
        onSuccess: onApiSuccess.type,
        onError: onApiError.type
      })
    );
  };
  return (
    <div className="save-offer-container mt-1">
      <SaveOfferModal
        email={emailStatus.email}
        isActionEnabled={emailStatus.isValid}
        handleChange={handleEmailChange}
        handleSubmit={handleSaveOffer}
        submitStatus={submitStatus}
        onModalClose={onModalClose}
      />
    </div>
  );
};
